import { render, staticRenderFns } from "./consultDoctor.vue?vue&type=template&id=fc3838fc&scoped=true"
import script from "./consultDoctor.vue?vue&type=script&lang=js"
export * from "./consultDoctor.vue?vue&type=script&lang=js"
import style0 from "./consultDoctor.vue?vue&type=style&index=0&id=fc3838fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3838fc",
  null
  
)

export default component.exports